import { render } from "./InactiveSubscription.vue?vue&type=template&id=6533da10"
import script from "./InactiveSubscription.vue?vue&type=script&lang=js"
export * from "./InactiveSubscription.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__